import React from "react";
import { Link } from "react-router-dom";
import { dishes } from "../data/dishes";
import { offers, arrivals, arrivalsIntro } from "../data/offers";
import { useTheme, useDocumentTitle, useSite } from "../hooks/useSite";

export default function OffersPage() {
  useTheme(dishes[2]);
  useDocumentTitle("Offers");
  const { openModal } = useSite();
  const gallery = offers.map((o) => ({ src: o.src, alt: o.alt }));
  return (
    <>
      <section className="ro-collection-intro">
        <div className="ro-container">
          <h1>
            <strong className="ro-italic">Offers</strong>
            <br />
            <span className="ro-outline">&amp; just in</span>
          </h1>
          <p className="ro-lead">Current promotional posters from the café. Dates, minimum order and eligibility are set by RollOver.</p>
        </div>
      </section>
      <section className="ro-section">
        <div className="ro-container">
          <h2 className="ro-collection-sub">
            Current <span className="ro-outline">offers.</span>
          </h2>
          <div className="ro-posters">
            {offers.map((o, i) => (
              <button key={o.id} type="button" className="ro-poster" onClick={() => openModal("gallery", { photos: gallery, index: i, title: "Offers" })} aria-label={`Open poster: ${o.alt}`}>
                <img src={o.src} alt="" loading="lazy" />
              </button>
            ))}
          </div>
          <p className="ro-micro" style={{ marginTop: 30, textAlign: "center" }}>
            Posters are shown as published by the café. Verify validity dates and terms before ordering; delivery prices on Swiggy and Zomato may differ.
          </p>
        </div>
      </section>
      <section className="ro-section ro-tinted" id="just-in">
        <div className="ro-container">
          <h2 className="ro-collection-sub">
            Just <span className="ro-outline">in.</span>
          </h2>
          <p className="ro-lead" style={{ textAlign: "center", maxWidth: 760, margin: "0 auto 50px" }}>
            {arrivalsIntro}
          </p>
          <div className="ro-arrivals">
            {arrivals.map((a) => {
              const inner = (
                <>
                  <img src={a.src} alt={a.alt} loading="lazy" />
                  <h3 className="ro-italic">{a.title}</h3>
                  <p>{a.text}</p>
                </>
              );
              return a.to ? (
                <Link key={a.id} to={a.to} className="ro-arrival">
                  {inner}
                </Link>
              ) : (
                <div key={a.id} className="ro-arrival">
                  {inner}
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
